import { render, staticRenderFns } from "./PesquisaLegislacao.vue?vue&type=template&id=7d5b3d6a&scoped=true"
import script from "./PesquisaLegislacao.vue?vue&type=script&lang=js"
export * from "./PesquisaLegislacao.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PesquisaLegislacao.vue?vue&type=style&index=1&id=7d5b3d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5b3d6a",
  null
  
)

export default component.exports